
import PageSection from '~/components/PageSection.vue'


export default {
  name: 'PageNotificationBar',
  components: {PageSection},
  props: {
    cssClass: {
      type: String,
      default: 'bg-kip-yellow'
    },
    innerClass: {
      type: String,
      default: 'flex flex-row items-center justify-between'
    }
  }
}
